import "./plan-card-title.scss"
import FontPlanBody5White from "../../fonts/font-plan-body-5-white/font-plan-body-5-white"

interface ICurrentPlanIndicationStatus {
    labelTitle?: string
    labelBgColorVariable?: string,

}

const PlanCardTitle: React.FC<ICurrentPlanIndicationStatus> = ({labelTitle, labelBgColorVariable}) => {
    return (
        <div className="plan-card-title">
            <div style={{backgroundColor: labelBgColorVariable}} className="offered-plan-card-label-wrapper">
                <FontPlanBody5White>{labelTitle}</FontPlanBody5White>
            </div>
        </div>
    )
}

export default PlanCardTitle;